import { ListItem } from '../utility'
import { BaseEnumEx } from './base-enum-ex'
import { DataMap } from '@grapecity/wijmo.grid'

// NOTE: Make sure this stays in sync with the server-side enum
export enum DayOfWeek {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}

export class DayOfWeekEx extends BaseEnumEx {
    public static toDisplay(item: DayOfWeek) {
        switch (item) {
            case DayOfWeek.Sunday:
                return 'Sunday'
            case DayOfWeek.Monday:
                return 'Monday'
            case DayOfWeek.Tuesday:
                return 'Tuesday'
            case DayOfWeek.Wednesday:
                return 'Wednesday'
            case DayOfWeek.Thursday:
                return 'Thursday'
            case DayOfWeek.Friday:
                return 'Friday'
            case DayOfWeek.Saturday:
                return 'Saturday'
        }
        return 'Unknown'
    }

    public static toDataMap(): DataMap {
        return new DataMap(DayOfWeekEx.ToListItems(), 'value', 'display')
    }

    public static ToListItems(): ListItem<number>[] {
        return [
            new ListItem(DayOfWeek.Sunday, DayOfWeekEx.toDisplay(DayOfWeek.Sunday)),
            new ListItem(DayOfWeek.Monday, DayOfWeekEx.toDisplay(DayOfWeek.Monday)),
            new ListItem(DayOfWeek.Tuesday, DayOfWeekEx.toDisplay(DayOfWeek.Tuesday)),
            new ListItem(DayOfWeek.Wednesday, DayOfWeekEx.toDisplay(DayOfWeek.Wednesday)),
            new ListItem(DayOfWeek.Thursday, DayOfWeekEx.toDisplay(DayOfWeek.Thursday)),
            new ListItem(DayOfWeek.Friday, DayOfWeekEx.toDisplay(DayOfWeek.Friday)),
            new ListItem(DayOfWeek.Saturday, DayOfWeekEx.toDisplay(DayOfWeek.Saturday)),
        ]
    }
}
